var map = {
	"./1.png": 68,
	"./2.png": 134,
	"./9.jpg": 135,
	"./Android-amico.svg": 136,
	"./Annotation-pana.svg": 137,
	"./Application programming interface-amico.svg": 138,
	"./Application programming interface-cuate.svg": 139,
	"./Application programming interface-pana.svg": 140,
	"./Blog post-rafiki.svg": 141,
	"./Business Plan-amico.svg": 142,
	"./Business Plan-pana.svg": 143,
	"./Certification-amico.svg": 144,
	"./Email campaign-rafiki.svg": 145,
	"./Fingerprint-pana.svg": 146,
	"./Firmware-amico.svg": 147,
	"./Get in touch-pana.svg": 148,
	"./Hard drive-pana.svg": 149,
	"./Online popularity-amico.svg": 150,
	"./Real-time Sync-pana.svg": 151,
	"./Safe-pana.svg": 152,
	"./Server-cuate.svg": 153,
	"./Social ideas-pana.svg": 154,
	"./address_image.svg": 155,
	"./ai-fundamentals-practitioner-badge.1.png": 156,
	"./ai-fundamentals-skills-badge.1.png": 157,
	"./animated_logo.svg": 158,
	"./blogs_image.svg": 159,
	"./bsl_logo.png": 160,
	"./citi_logo.jpeg": 161,
	"./cloud_infrastructure.svg": 162,
	"./codeInLogo.png": 163,
	"./contactMail.png": 164,
	"./coursera_logo.png": 165,
	"./credly_logo.png": 166,
	"./dart_logo.png": 167,
	"./dart_logo.webp": 168,
	"./data_science.svg": 169,
	"./deeplearning_ai_logo.png": 170,
	"./delhivery_logo.png": 171,
	"./developerActivity.svg": 172,
	"./dsc_logo.png": 173,
	"./education.svg": 174,
	"./experience.svg": 175,
	"./facebook_logo.png": 176,
	"./feelingProud.svg": 177,
	"./freecopy_logo.png": 178,
	"./fullstack.svg": 179,
	"./gcp_logo.png": 180,
	"./github_logo.png": 181,
	"./googleAssistant.jpg": 182,
	"./googleAssistant.svg": 183,
	"./google_logo.png": 184,
	"./ibm_logo.png": 185,
	"./iiitk_logo.png": 186,
	"./intel_logo.jpg": 187,
	"./iu_logo.png": 188,
	"./jsFramework.svg": 189,
	"./legato_logo.png": 190,
	"./lockheed_logo.jpg": 191,
	"./manOnTable.svg": 192,
	"./microsoft_logo.png": 193,
	"./mlops-skills-badge.1.png": 194,
	"./mozilla_logo.png": 195,
	"./muffito_logo.png": 196,
	"./nextuLogo.jpg": 197,
	"./nist_logo.png": 198,
	"./nptel_logo.png": 199,
	"./nsa_logo.svg": 200,
	"./nyu_logo.png": 201,
	"./portfolio.gif": 202,
	"./programmer.svg": 203,
	"./projects_image.svg": 204,
	"./pwa.png": 205,
	"./saayaHealthLogo.png": 206,
	"./sasha_hs.webp": 207,
	"./stanford_logo.png": 208,
	"./talksCardBack.svg": 209,
	"./talksCardBackAlt.svg": 210,
	"./tiktok_logo.png": 211,
	"./twinthread_logo.jpeg": 212,
	"./ui_ux_design.svg": 213,
	"./university-of-virginia-2.svg": 214,
	"./us_dol_logo.webp": 215,
	"./uva_logo.png": 216,
	"./uva_logo.svg": 217,
	"./vt_logo.jpeg": 218,
	"./vt_logo.png": 219
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 36;